import { PageTypes } from 'shared/components/PageList/type'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'

import { ReactComponent as LockIcon } from './icons/lock.svg'

type CoverPageTypes = PageTypes.coverFront | PageTypes.coverBack

type CoverPageInfoProps = {
  type: CoverPageTypes
}

const CoverPageInfo: React.FC<CoverPageInfoProps> = ({ type }) => {
  const titleLabel = `Pages.cover.label.${
    type === PageTypes.coverFront ? 'front' : 'back'
  }`

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      paddingLeft={4}
      paddingRight={4}
      width="100%"
      maxWidth="100%"
    >
      <Text
        id={titleLabel}
        color={theme => theme.color.base.c7}
        size={12}
        weight={600}
        whiteSpace="nowrap"
        textOverflow="ellipsis"
      />

      <LockIcon />
    </Flex>
  )
}

export default CoverPageInfo
